module.exports = require("./ti.d.ts");